<script>
import { BFormRow } from "bootstrap-vue";

export default {
  extends: BFormRow
};
</script>